import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Card, Spinner, Button, Table, Col, Row, Alert } from 'react-bootstrap';
import { FaEdit, FaTrash, FaPlus, FaEye, FaArrowLeft } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { getAllProduct, productDeletion } from "./productAction";
import $ from 'jquery';
import moment from 'moment'
import Swal from 'sweetalert2'
import Tooltip from '@mui/material/Tooltip';
import { getSRolePermission } from '../userRolePermission/rolepermissionAction';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Button1 from '@mui/material/Button';


const ProductList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const firstUpdate = useRef(true);
    const { products, pisLoading, pdstatus, pdmessage } = useSelector((state) => state.productList);
    console.log("just",products)
   

    useEffect(() => {
        dispatch(getSRolePermission());
        
    }, []);
  
    const { permissionisLoading, combinedrolepermissiondetails } = useSelector(
        (state) => state.rolePermissionList
      );

      const filteredPermissions = combinedrolepermissiondetails.filter(
        (item) => item.label === "Add Product"
      );
      let menu_view = 0;
      let menu_add = 0;
      let menu_edit = 0;
      let menu_delete = 0;
      
      if (filteredPermissions.length > 0) {
        const permission = filteredPermissions[0];
        menu_view = permission.menu_view;
        menu_add = permission.menu_add;
        menu_edit = permission.menu_edit;
        menu_delete = permission.menu_delete;
      }
    //console.log(suppliers);
    const onSubProductSingle = (id,name, e) => {
        e.preventDefault();
       //console.log('select role '+id);
       navigate('/subproductListId/' + id + "/" + name); 
    }
   
    useLayoutEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            dispatch(getAllProduct());
           
        }

        // console.log("componentDidUpdateFunction");
    },[]);
    useEffect(() => {
        dispatch(getAllProduct());
        
    }, [pdmessage]);

    if (pisLoading) {
        return (
            <>
                <Container className="my-4 mx-4 container-xl justify-content-center">
                    <h2>Loading.....</h2>
                    {pisLoading && <Spinner variant='info' center="true" animation='border' />}

                </Container>
            </>
        );
    }
console.log(products.length);
    // if (products.length === 0) {
    //     return (
    //         <>
    //             <Container className="my-4 mx-4 container-xl">
    //                 {/* <div style={{ display: 'flex', justifyContent: 'flex-start',marginLeft:'130px',marginRight:'-100px' }}><Link className="btn alink btncolorb" variant="btncolorb" to="/createProduct"><FaPlus className='fwcolor' /> Add Product</Link>{' '}</div> */}
    //             </Container>
    //             <Container className="my-4 mx-4 container-xl" >
    //                 {/* <h2 style={{marginLeft:'130px',marginRight:'-100px'}}>No Product to display.....</h2> */}
    //                 <table id="example" className="table table-hover table-bordered display" style={{ "width": "100%",marginTop:'-80px' }}>
    //                     <thead>
    //                         <tr>
    //                             <th style={{backgroundColor:'rgb(0 0 0 / 3%)',padding:'10px'}}><Link to="/" style={{ marginLeft: '0px', marginRight: '-100px' }}>{menu_add===1 &&(<Link className="btn alink btncolorb" variant="btncolorb" to="/createProduct"><FaPlus className='fwcolor' /> Add Product</Link>)}<br /><span className="badge bg-success" style={{ backgroundColor: 'rgb(156 186 237)', color: 'white' }}><FaArrowLeft />&nbsp;Go Back</span></Link><h4>Product List</h4></th>

    //                         </tr>
    //                     </thead>
    //                     <tbody>
    //                         <tr>
    //                             <td style={{textAlign:'center'}}>No Data Available.</td>
                               
    //                         </tr>


    //                     </tbody>
    //                 </table>

    //             </Container>
    //         </>
    //     );
    // }


    //const suppliers = useSelector(state => state.suppliers)
    //const suppliers = useSelector(getSupplierSuccess);

    //const orderedSuppliers = products.slice().sort((a, b) => b.id.localeCompare(a.id))
console.log("products",products)
    const renderedProduct = products.map((product, index) => (
        
        <tr key={product.id}>
            <td>{index+ 1}</td>
            {/* <td>{product.supplier_code}</td> */}
            <td>{product.product_name}</td>
            <td>{product?.service_type}</td>
            <td>{product.phone_number}</td>
            <td>{product?.country_name}</td>
            <td>{product?.city_name}</td>
            {/* <td>{ moment(product.daily_start_time).format('hh:mm A')}</td>
            <td>{ moment(product.daily_end_time).format('hh:mm A')}</td> */}
            <td>{product.status == 1 ? <span className="badge bg-success"> Enable</span> : <span className="badge bg-danger"> Disable</span>}</td>
            <td className="tdstyle" style={{width:'107px'}}><> {menu_edit===1 &&(<Button className="btn btn-sm btn-warning "  onClick={(e) => onProductModify(product.id,e)}  id={product.id} ><FaEdit className='fwcolor' /></Button>)}&nbsp;
             {menu_delete===1 &&(<Button className="btn btn-sm btn-danger"  onClick={(e) => onProductDelete(product.id, e)} ><FaTrash className='fwcolor' /></Button>)}&nbsp;{menu_view===1 &&(<Tooltip title="View Sub Products"><Button className="btn btn-sm btn-primary"  onClick={(e) => onSubProductSingle(product.id,product.product_name,e)}  id={product.id} ><FaEye className='fwcolor' /></Button></Tooltip>)}</></td>
            {/* <td className="tdstyle" style={{width:'107px'}}><> <Button className="btn btn-sm btn-warning"  onClick={(e) => onProductModify(product.id,e)}  id={product.id} ><FaEdit className='fwcolor' /></Button> <Button className="btn btn-sm btn-danger"  onClick={(e) => onProductDelete(product.id, e)} ><FaTrash className='fwcolor' /></Button>&nbsp;<Tooltip title="View Sub Products"><Button className="btn btn-sm btn-primary"  onClick={(e) => onSubProductSingle(product.id,product.product_name,e)}  id={product.id} ><FaEye className='fwcolor' /></Button></Tooltip></></td> */}
        </tr>
    ))

    
    const onProductDelete = (id, e) => {
        e.preventDefault();
        Swal.fire({
            title: 'Are you sure want to delete the product?',
            showDenyButton: true,
            icon:'error',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: 'No',
            customClass: {
              actions: 'my-actions',
              cancelButton: 'order-1 right-gap',
              confirmButton: 'order-2',
              denyButton: 'order-3',
            }
          }).then((result) => {
            if (result.isConfirmed) {
                dispatch(productDeletion(id)).then(() => {
                    dispatch(getAllProduct()); 
                  Swal.fire('product Deleted Successfully!', '', 'success');
                })
            }
            // if (result.isConfirmed) {
            //     dispatch(productDeletion(id));
            //     dispatch(getAllProduct());
            //     navigate('/productList');
            //     getAllProduct();
               
                  
            //   Swal.fire('Product Deleted Successfully!', '', 'success')
            // }
             else if (result.isDenied) {
              Swal.fire('Changes are not saved', 'Your Data is safe', 'info')
            }
          })
 

    }
    const onPagepath = () => {
        navigate('/createProduct');
    }

    const onProductModify = (id, e) => {
        e.preventDefault();
       //console.log('select role '+id);
       navigate('/modifyProduct/' + id); 
   }


    //initialize datatable
    $(document).ready(function () {
        setTimeout(function () {
            if ($.fn.dataTable.isDataTable('#example')) {
                const table = $('#example').DataTable();
            }
            else {
                const table = $('#example').DataTable({
                    paging: true,
                    pagingType: 'full_numbers',
                    pageLength: 5,
                    processing: true,
                    dom: 'Bfrtip',
                    buttons: ['csv', 'print'],
                    // buttons: ['copy', 'csv', 'print'],
                    destroy: true,

                });
            }

        },
            1000
        );
    });
    return (
        <>

            <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2" style={{fontFamily:'Times New Roman', fontWeight:'600' }}>Product List</h3>
                        {/* {menu_add===1 &&(<div style={{ display: 'flex', justifyContent: 'flex-start' }}><Link className="btn alink btncolorb" variant="btncolorb" to="/createProduct"><FaPlus className='fwcolor' /> Add Product</Link>{' '}</div>)} */}
                        {menu_add===1 &&(   <Button1 variant="contained" onClick={onPagepath} color="success" style={{ width: '', float: '', backgroundColor: '#d1af2b', fontSize: '10px'}} startIcon={<AddCircleOutlineIcon />}>
                            Add Product
                        </Button1>)}
                    </div>
                    <div className="card-body">
                        <Row>
                        <Link to="/"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
                        </Row>
                        <br />
                        {products?.length
                            ? (
                                <table id="example" className="table table-hover table-bordered display" style={{ "width": "100%" }}>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                             {/* <th>Image</th> */}
                                            <th>Product Name</th>
                                            <th>Service Type</th>
                                            <th>Phone No</th>
                                            <th>Country</th>
                                            <th>City</th>
                                            {/* <th>Daily Start Time</th>
                                            <th>Daily End Time</th> */}
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {renderedProduct}


                                    </tbody>
                                </table>
                            ) : <p style={{textAlign:'center'}}>No Products to display</p>
                        }

                    </div>
                </div>
            </div>

        </>
    )
}

export default ProductList
